var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_2",
    "data-name": "Component 27 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.527,
    height: 159.172,
    viewBox: "0 0 193.527 159.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M-2832.452,5224.345h193.527V5065.173h-193.527Z",
    transform: "translate(2925 -122)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M1088.984,1682.445l-3.4.007-17.977.042-4.388.011-27.267.061-46.168.107-22.393.05-5.234.013-24.51.055c-6.935-85.12,28.222-104.13,43.123-107.025.149.431.319.9.51,1.414,11,29.3,52.682,28.932,63.1-.582q.18-.51.356-1.03c4.167.767,12.167,3.7,20.817,14.562h0C1079.2,1604.256,1092.916,1631.322,1088.984,1682.445Z",
    transform: "translate(-936.747 -1575.568)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-92.548 -4943.173)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(2475.215 -92.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(-2362.364 5071.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 8.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M1085.231,1285.973s-.178,13.829-1.271,23.11-14.649,8.644-13.556,16.178-2.291,10.377-10.766,20.871,5.312,26.695,5.312,26.695l45.166-3.3v-83.554Z",
    transform: "translate(-1032.603 -1266.011)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M1344.365,1291.949s.967,7.853,2.061,17.135,14.649,8.644,13.556,16.178,2.291,10.377,10.766,20.871-5.312,26.695-5.312,26.695l-45.166-3.3v-83.554Z",
    transform: "translate(-1242.756 -1266.011)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M1206.766,1193.177s6.119-6.837,15.616-5.88,19.248,10.119,23.089,20.238-.326,25.6-10.578,30.3-24.593-.206-24.593-.206-9.591-2.339-12.25-16.287S1198.641,1193.177,1206.766,1193.177Z",
    transform: "translate(-1145.175 -1187.906)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(0 8.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 93.729,
    height: 55.29,
    transform: "translate(28.581 154.24)",
    fill: "#f45860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1088.984,1548.5l-3.4.007-17.977.042-4.388.011-27.267.061-46.168.107-22.393.05-5.234.013-24.51.055c-6.935-85.12,28.222-104.131,43.123-107.025l.245-.046c.711-.131,5.079-.269,8.335-.357a11.057,11.057,0,0,0,8.514-4.312c4.989-6.564,4.484-16.352,4.528-23.087,0-.406,0-.8,0-1.183-.006-.721-.024-1.4-.046-2.022l-.013-.345c-.066-1.738-.168-2.775-.168-2.775h23.126a75.553,75.553,0,0,0-.173,9.063c0,.07,0,.14.007.212.044,1.124.114,2.252.221,3.378.253,2.716.365,5.416.684,7.98a14.861,14.861,0,0,0,14.179,12.957c.536.022,1.049.053,1.52.09a12.272,12.272,0,0,1,3.006.249c4.167.767,12.167,3.695,20.817,14.562h0C1079.2,1470.31,1092.916,1497.376,1088.984,1548.5Z",
    transform: "translate(-936.747 -1371.408)",
    fill: "#c3c3f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1284.006,1416.756c-1.9,3.529-4.793,6.73-8.914,6.214-6.459-.807-11.623-6.844-13.812-10.134-.007-.721-.024-1.4-.046-2.022,0-.118-.009-.234-.013-.345l11.54-2.775h11.417A75.473,75.473,0,0,0,1284.006,1416.756Z",
    transform: "translate(-1195.642 -1371.408)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M1088.984,1682.445l-3.4.007-17.977.042-4.388.011-27.267.061-46.168.107-22.393.05-5.234.013-24.51.055c-6.935-85.12,28.222-104.13,43.123-107.025.149.431.319.9.51,1.414,11,29.3,52.682,28.932,63.1-.582q.18-.51.356-1.03c4.167.767,12.167,3.7,20.817,14.562h0C1079.2,1604.256,1092.916,1631.322,1088.984,1682.445Z",
    transform: "translate(-936.747 -1505.354)",
    fill: "#4527a0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(0 70.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(-32.828 -19.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(8.586 115.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M821.629,2051.4a345.632,345.632,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,821.629,2051.4Z",
    transform: "translate(-816.803 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M906.594,2051.4a343.1,343.1,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,906.594,2051.4Z",
    transform: "translate(-884.596 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M991.559,2051.4a345.937,345.937,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,991.559,2051.4Z",
    transform: "translate(-952.389 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M1076.523,2051.4a347.62,347.62,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1076.523,2051.4Z",
    transform: "translate(-1020.181 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M1161.488,2051.4a342.543,342.543,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1161.488,2051.4Z",
    transform: "translate(-1087.974 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M1246.453,2051.4a346.47,346.47,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1246.453,2051.4Z",
    transform: "translate(-1155.767 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M1331.417,2051.4a343.667,343.667,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1331.417,2051.4Z",
    transform: "translate(-1223.559 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M1416.382,2051.4a339.8,339.8,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1416.382,2051.4Z",
    transform: "translate(-1291.352 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M1501.347,2051.4a345.328,345.328,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1501.347,2051.4Z",
    transform: "translate(-1359.145 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M1586.311,2051.4a339.8,339.8,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.01-.008h0A1.4,1.4,0,0,0,1586.311,2051.4Z",
    transform: "translate(-1426.937 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M1671.276,2051.4a343.667,343.667,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1671.276,2051.4Z",
    transform: "translate(-1494.73 -2049.985)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M1756.241,2051.4a340.908,340.908,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1756.241,2051.4Z",
    transform: "translate(-1562.523 -2049.985)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0 101.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M779.147,1980.2a362.014,362.014,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,779.147,1980.2Z",
    transform: "translate(-774.321 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M864.112,1980.2a360.191,360.191,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,864.112,1980.2Z",
    transform: "translate(-842.114 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M949.076,1980.2a362.641,362.641,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,949.076,1980.2Z",
    transform: "translate(-909.906 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M1034.041,1980.2a364.829,364.829,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1034.041,1980.2Z",
    transform: "translate(-977.699 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M1119.006,1980.2a369.286,369.286,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1119.006,1980.2Z",
    transform: "translate(-1045.492 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M1203.97,1980.2a360.479,360.479,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1203.97,1980.2Z",
    transform: "translate(-1113.284 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M1288.935,1980.2a363.562,363.562,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1288.935,1980.2Z",
    transform: "translate(-1181.077 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M1373.9,1980.2a360.479,360.479,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1373.9,1980.2Z",
    transform: "translate(-1248.87 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M1458.864,1980.2a367.987,367.987,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1458.864,1980.2Z",
    transform: "translate(-1316.662 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M1543.829,1980.2a363.562,363.562,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1543.829,1980.2Z",
    transform: "translate(-1384.455 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M1628.794,1980.2a363.562,363.562,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1628.794,1980.2Z",
    transform: "translate(-1452.248 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M1713.758,1980.2a360.479,360.479,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1713.758,1980.2Z",
    transform: "translate(-1520.04 -1978.784)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M1798.723,1980.2a356.23,356.23,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.077l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.077l.009-.009h0A1.4,1.4,0,0,0,1798.723,1980.2Z",
    transform: "translate(-1587.833 -1978.784)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(8.586 86.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M821.629,1908.281a365.752,365.752,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,821.629,1908.281Z",
    transform: "translate(-816.803 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M906.594,1908.281a362.922,362.922,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,906.594,1908.281Z",
    transform: "translate(-884.596 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M991.559,1908.281a366.1,366.1,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,991.559,1908.281Z",
    transform: "translate(-952.389 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M1076.523,1908.281a367.978,367.978,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1076.523,1908.281Z",
    transform: "translate(-1020.181 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M1161.488,1908.281a362.294,362.294,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1161.488,1908.281Z",
    transform: "translate(-1087.974 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M1246.453,1908.281a366.689,366.689,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1246.453,1908.281Z",
    transform: "translate(-1155.767 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M1331.417,1908.281a363.552,363.552,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1331.417,1908.281Z",
    transform: "translate(-1223.559 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M1416.382,1908.281a359.232,359.232,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1416.382,1908.281Z",
    transform: "translate(-1291.352 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M1501.347,1908.281a365.409,365.409,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1501.347,1908.281Z",
    transform: "translate(-1359.145 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M1586.311,1908.281a359.232,359.232,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.01-.008h0A1.4,1.4,0,0,0,1586.311,1908.281Z",
    transform: "translate(-1426.937 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M1671.276,1908.281a363.552,363.552,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1671.276,1908.281Z",
    transform: "translate(-1494.73 -1906.87)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M1756.241,1908.281a360.468,360.468,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1756.241,1908.281Z",
    transform: "translate(-1562.523 -1906.87)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0 72.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M779.147,1837.08a368.267,368.267,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,779.147,1837.08Z",
    transform: "translate(-774.321 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M864.112,1837.08a366.382,366.382,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,864.112,1837.08Z",
    transform: "translate(-842.114 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M949.076,1837.08a368.916,368.916,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,949.076,1837.08Z",
    transform: "translate(-909.906 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M1034.041,1837.08a371.181,371.181,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1034.041,1837.08Z",
    transform: "translate(-977.699 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M1119.006,1837.08a375.8,375.8,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1119.006,1837.08Z",
    transform: "translate(-1045.492 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M1203.97,1837.08a366.679,366.679,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1203.97,1837.08Z",
    transform: "translate(-1113.284 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M1288.935,1837.08a369.869,369.869,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1288.935,1837.08Z",
    transform: "translate(-1181.077 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M1373.9,1837.08a366.679,366.679,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1373.9,1837.08Z",
    transform: "translate(-1248.87 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M1458.864,1837.08a374.45,374.45,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1458.864,1837.08Z",
    transform: "translate(-1316.662 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M1543.829,1837.08a369.869,369.869,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1543.829,1837.08Z",
    transform: "translate(-1384.455 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M1628.794,1837.08a369.869,369.869,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1628.794,1837.08Z",
    transform: "translate(-1452.248 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M1713.758,1837.08a366.679,366.679,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1713.758,1837.08Z",
    transform: "translate(-1520.04 -1835.669)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M1798.723,1837.08a362.284,362.284,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.078l1.93,1.738,1.93-1.738c.029-.026.059-.049.086-.078l.009-.008h0A1.4,1.4,0,0,0,1798.723,1837.08Z",
    transform: "translate(-1587.833 -1835.669)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(8.586 57.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M821.629,1765.165a352.469,352.469,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,821.629,1765.165Z",
    transform: "translate(-816.803 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M906.594,1765.165a349.841,349.841,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,906.594,1765.165Z",
    transform: "translate(-884.596 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M991.559,1765.165a352.787,352.787,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,991.559,1765.165Z",
    transform: "translate(-952.389 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M1076.523,1765.165a354.536,354.536,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1076.523,1765.165Z",
    transform: "translate(-1020.181 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M1161.488,1765.165a349.257,349.257,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1161.488,1765.165Z",
    transform: "translate(-1087.974 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M1246.453,1765.165a353.34,353.34,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1246.453,1765.165Z",
    transform: "translate(-1155.767 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M1331.417,1765.165a350.426,350.426,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1331.417,1765.165Z",
    transform: "translate(-1223.559 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M1416.382,1765.165a346.409,346.409,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1416.382,1765.165Z",
    transform: "translate(-1291.352 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M1501.347,1765.165a352.152,352.152,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1501.347,1765.165Z",
    transform: "translate(-1359.145 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M1586.311,1765.165a346.409,346.409,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.01-.008h0A1.4,1.4,0,0,0,1586.311,1765.165Z",
    transform: "translate(-1426.937 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M1671.276,1765.165a350.426,350.426,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1671.276,1765.165Z",
    transform: "translate(-1494.73 -1763.754)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M1756.241,1765.165a347.558,347.558,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1756.241,1765.165Z",
    transform: "translate(-1562.523 -1763.754)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(0 43.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M779.147,1693.964a347.878,347.878,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,779.147,1693.964Z",
    transform: "translate(-774.321 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M864.112,1693.964a346.193,346.193,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,864.112,1693.964Z",
    transform: "translate(-842.114 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M949.076,1693.964a348.457,348.457,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,949.076,1693.964Z",
    transform: "translate(-909.906 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M1034.041,1693.964a350.478,350.478,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1034.041,1693.964Z",
    transform: "translate(-977.699 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M1119.006,1693.964a354.589,354.589,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1119.006,1693.964Z",
    transform: "translate(-1045.492 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M1203.97,1693.964a346.46,346.46,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1203.97,1693.964Z",
    transform: "translate(-1113.284 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M1288.935,1693.964a349.309,349.309,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1288.935,1693.964Z",
    transform: "translate(-1181.077 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M1373.9,1693.964a346.46,346.46,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1373.9,1693.964Z",
    transform: "translate(-1248.87 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M1458.864,1693.964a353.392,353.392,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1458.864,1693.964Z",
    transform: "translate(-1316.662 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M1543.829,1693.964a349.309,349.309,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1543.829,1693.964Z",
    transform: "translate(-1384.455 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M1628.794,1693.964a349.309,349.309,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1628.794,1693.964Z",
    transform: "translate(-1452.248 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M1713.758,1693.964a346.46,346.46,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1713.758,1693.964Z",
    transform: "translate(-1520.04 -1692.553)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M1798.723,1693.964a342.532,342.532,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.009c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.009h0A1.4,1.4,0,0,0,1798.723,1693.964Z",
    transform: "translate(-1587.833 -1692.553)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(8.586 28.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M821.629,1622.05a365.752,365.752,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,821.629,1622.05Z",
    transform: "translate(-816.803 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M906.594,1622.05a362.922,362.922,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,906.594,1622.05Z",
    transform: "translate(-884.596 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M991.559,1622.05a366.1,366.1,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,991.559,1622.05Z",
    transform: "translate(-952.389 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M1076.523,1622.05a367.978,367.978,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1076.523,1622.05Z",
    transform: "translate(-1020.181 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M1161.488,1622.05a362.294,362.294,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1161.488,1622.05Z",
    transform: "translate(-1087.974 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M1246.453,1622.05a366.689,366.689,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1246.453,1622.05Z",
    transform: "translate(-1155.767 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M1331.417,1622.05a363.552,363.552,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1331.417,1622.05Z",
    transform: "translate(-1223.559 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M1416.382,1622.05a359.232,359.232,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1416.382,1622.05Z",
    transform: "translate(-1291.352 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M1501.347,1622.05a365.409,365.409,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1501.347,1622.05Z",
    transform: "translate(-1359.145 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M1586.311,1622.05a359.232,359.232,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.01-.008h0A1.4,1.4,0,0,0,1586.311,1622.05Z",
    transform: "translate(-1426.937 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M1671.276,1622.05a363.552,363.552,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1671.276,1622.05Z",
    transform: "translate(-1494.73 -1620.639)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M1756.241,1622.05a360.468,360.468,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.025.059-.049.086-.077l.009-.008h0A1.4,1.4,0,0,0,1756.241,1622.05Z",
    transform: "translate(-1562.523 -1620.639)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(0 14.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M779.147,1550.849a358.966,358.966,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,779.147,1550.849Z",
    transform: "translate(-774.321 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M864.112,1550.849a357.174,357.174,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,864.112,1550.849Z",
    transform: "translate(-842.114 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M949.076,1550.849a359.583,359.583,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,949.076,1550.849Z",
    transform: "translate(-909.906 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M1034.041,1550.849a361.734,361.734,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1034.041,1550.849Z",
    transform: "translate(-977.699 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M1119.006,1550.849a366.114,366.114,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1119.006,1550.849Z",
    transform: "translate(-1045.492 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M1203.97,1550.849a357.457,357.457,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1203.97,1550.849Z",
    transform: "translate(-1113.284 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M1288.935,1550.849a360.489,360.489,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1288.935,1550.849Z",
    transform: "translate(-1181.077 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M1373.9,1550.849a357.457,357.457,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1373.9,1550.849Z",
    transform: "translate(-1248.87 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M1458.864,1550.849a364.838,364.838,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1458.864,1550.849Z",
    transform: "translate(-1316.662 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M1543.829,1550.849a360.489,360.489,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1543.829,1550.849Z",
    transform: "translate(-1384.455 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M1628.794,1550.849a360.489,360.489,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1628.794,1550.849Z",
    transform: "translate(-1452.248 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M1713.758,1550.849a357.457,357.457,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1713.758,1550.849Z",
    transform: "translate(-1520.04 -1549.438)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M1798.723,1550.849a353.279,353.279,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.379h0l.009.008c.027.028.057.052.086.077l1.93,1.738,1.93-1.738c.029-.026.059-.05.086-.077l.009-.008h0A1.4,1.4,0,0,0,1798.723,1550.849Z",
    transform: "translate(-1587.833 -1549.438)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(8.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M821.629,1478.934a348.457,348.457,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,821.629,1478.934Z",
    transform: "translate(-816.803 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M906.594,1478.934a345.888,345.888,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,906.594,1478.934Z",
    transform: "translate(-884.596 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M991.559,1478.934a348.767,348.767,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,991.559,1478.934Z",
    transform: "translate(-952.389 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M1076.523,1478.934a350.478,350.478,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1076.523,1478.934Z",
    transform: "translate(-1020.181 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M1161.488,1478.934a345.318,345.318,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1161.488,1478.934Z",
    transform: "translate(-1087.974 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M1246.453,1478.934a349.309,349.309,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1246.453,1478.934Z",
    transform: "translate(-1155.767 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M1331.417,1478.934a346.46,346.46,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1331.417,1478.934Z",
    transform: "translate(-1223.559 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M1416.382,1478.934a342.532,342.532,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1416.382,1478.934Z",
    transform: "translate(-1291.352 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M1501.347,1478.934a348.148,348.148,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1501.347,1478.934Z",
    transform: "translate(-1359.145 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M1586.311,1478.934a342.532,342.532,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.01-.008h0A1.4,1.4,0,0,0,1586.311,1478.934Z",
    transform: "translate(-1426.937 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M1671.276,1478.934a346.46,346.46,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1671.276,1478.934Z",
    transform: "translate(-1494.73 -1477.523)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M1756.241,1478.934a343.656,343.656,0,0,1-3.415-1.411,1.408,1.408,0,0,0-1.022,2.38h0l.009.008c.027.028.057.052.086.078l1.93,1.737,1.93-1.737c.029-.026.059-.05.086-.078l.009-.008h0A1.4,1.4,0,0,0,1756.241,1478.934Z",
    transform: "translate(-1562.523 -1477.523)",
    fill: "#69efad"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(54.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(0 21.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M1207.921,1336.078c0-2.815,1.68-3.6,3.978-3.6s4.161,2.282,4.161,5.1-1.772,6.04-4.07,6.04S1207.921,1338.893,1207.921,1336.078Z",
    transform: "translate(-1207.921 -1332.479)",
    fill: "#c3c3f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M1218.394,1349.725s-.576-2.5-2.765-1.966a1.775,1.775,0,0,1,1.054,2.312,2.664,2.664,0,0,0,.567,2.769S1216.55,1349.627,1218.394,1349.725Z",
    transform: "translate(-1214.071 -1344.61)",
    fill: "#c3c3f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M1391.785,1336.078c0-2.815-1.68-3.6-3.979-3.6s-4.161,2.282-4.161,5.1,1.772,6.04,4.07,6.04S1391.785,1338.893,1391.785,1336.078Z",
    transform: "translate(-1348.13 -1332.479)",
    fill: "#c3c3f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M1402.528,1349.725s.576-2.5,2.765-1.966a1.775,1.775,0,0,0-1.054,2.312,2.664,2.664,0,0,1-.568,2.769S1404.372,1349.627,1402.528,1349.725Z",
    transform: "translate(-1363.196 -1344.61)",
    fill: "#c3c3f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M1260.819,1269.373c-3.072,3.4-6.957,5.582-11.623,5.508-4.657.074-8.549-2.112-11.619-5.508a.474.474,0,0,0-.057-.061c-4.012-4.88-5.7-11.385-5.73-19.053v0a68.01,68.01,0,0,1,.6-8.978,12.6,12.6,0,0,1,.894-3.347c2.495-5.9,9.021-8.4,12.9-9.4a12.19,12.19,0,0,1,6.03,0c3.877.993,10.405,3.5,12.9,9.4a12.594,12.594,0,0,1,.894,3.347,70.949,70.949,0,0,1,.59,7.556v0C1266.766,1257.156,1265.12,1264.19,1260.819,1269.373Z",
    transform: "translate(-1226.965 -1228.157)",
    fill: "#c3c3f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.069,
    cy: 1.069,
    r: 1.069,
    transform: "translate(27.14 23.905)",
    fill: "#4527a0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1.069,
    cy: 1.069,
    r: 1.069,
    transform: "translate(14.51 23.905)",
    fill: "#4527a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M1338.913,1312.263c.406.208.178.689-.309.654-1.065-.077-2.569-.153-4.28-.145-3.367.017-4.237-.017-3.936-.89s3.679-.857,5.787-.554A9.006,9.006,0,0,1,1338.913,1312.263Z",
    transform: "translate(-1305.592 -1294.368)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M1257.643,1312.263c-.405.208-.178.689.309.654,1.066-.077,2.569-.153,4.28-.145,3.367.017,4.237-.017,3.936-.89s-3.68-.857-5.787-.554A9.01,9.01,0,0,0,1257.643,1312.263Z",
    transform: "translate(-1247.427 -1294.368)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M1264.583,1330.024a6.583,6.583,0,0,0-6.356,4.909,4.026,4.026,0,0,0-2.805-.827,3.2,3.2,0,0,0-1.67.754,6.619,6.619,0,1,0,.16.754l0,0c.063-.081,1.574-1.944,4.167.015a6.646,6.646,0,0,0-.07.962,6.571,6.571,0,1,0,6.57-6.572Zm-17.17,12.487a5.915,5.915,0,1,1,5.917-5.914A5.923,5.923,0,0,1,1247.413,1342.511Zm17.17,0a5.915,5.915,0,1,1,5.917-5.914A5.922,5.922,0,0,1,1264.583,1342.511Z",
    transform: "translate(-1234.189 -1309.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(24.795 21.559)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M1340.068,1335.953l-8.339,8.339a5.87,5.87,0,0,1-1.128-1.964l7.5-7.5A5.877,5.877,0,0,1,1340.068,1335.953Z",
    transform: "translate(-1330.601 -1334.827)",
    fill: "#4527a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(26.775 23.54)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M1349.727,1346.691l-7.263,7.263a5.865,5.865,0,0,1-2.062-1.03l8.3-8.3A5.855,5.855,0,0,1,1349.727,1346.691Z",
    transform: "translate(-1340.402 -1344.629)",
    fill: "#4527a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(7.412 21.347)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M1253.693,1334.672l-8.2,8.2a5.83,5.83,0,0,1-.894-2.2l6.9-6.9A5.813,5.813,0,0,1,1253.693,1334.672Z",
    transform: "translate(-1244.597 -1333.778)",
    fill: "#4527a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(9.059 22.993)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M1262.35,1343.769l-7.762,7.762a5.922,5.922,0,0,1-1.845-1.246l8.361-8.361A5.96,5.96,0,0,1,1262.35,1343.769Z",
    transform: "translate(-1252.743 -1341.924)",
    fill: "#4527a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M1340.874,1339.186a5.923,5.923,0,0,1-5.917,5.914,5.914,5.914,0,0,1-3.619-1.24,5.913,5.913,0,1,1,7.486-9.15,5.954,5.954,0,0,1,.809.855,5.917,5.917,0,0,1,1.24,3.621Z",
    transform: "translate(-1304.563 -1312.026)",
    fill: "#4527a0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M1255.919,1339.186a5.91,5.91,0,0,1-10.082,4.194,6.031,6.031,0,0,1-.752-.91,5.828,5.828,0,0,1-.894-2.2,5.725,5.725,0,0,1-.1-1.087,5.923,5.923,0,0,1,5.914-5.916,5.946,5.946,0,0,1,3.284,1,5.909,5.909,0,0,1,2.632,4.919Z",
    transform: "translate(-1236.779 -1312.026)",
    fill: "#4527a0",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M1307.288,1400.939l5.246-.62s.125,1.652-2.2,1.893A2.854,2.854,0,0,1,1307.288,1400.939Z",
    transform: "translate(-1232.399 -1365.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(75.445 28.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M1311.05,1371.933c-.045,0-.089,0-.132-.006a.935.935,0,0,1-.741-.407c-.377-.587.126-3.046.23-3.533a.191.191,0,0,1,.373.08,8.831,8.831,0,0,0-.283,3.246.584.584,0,0,0,.454.233,1.514,1.514,0,0,0,1.134-.43.191.191,0,0,1,.28.26A1.885,1.885,0,0,1,1311.05,1371.933Z",
    transform: "translate(-1310.039 -1367.837)",
    fill: "#4527a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M1518.887,1878.037l-2.913.01-3.3-57.4Z",
    transform: "translate(-1396.273 -1700.897)",
    fill: "#120283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M1087.433,1878.037l2.913.01,3.3-57.4Z",
    transform: "translate(-1056.978 -1700.897)",
    fill: "#120283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M1597.456,1739.932l-3.4.008c4.769-55.117-20.037-92.324-20.037-92.324h0C1587.669,1661.743,1601.387,1688.809,1597.456,1739.932Z",
    transform: "translate(-1445.218 -1562.84)",
    fill: "#120283"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M1227.522,1230.137a2.6,2.6,0,0,1,1.6,1.409c.511,1.139.775-13.52,3.86-15.488s17.975-6.007,20.127-1.2,5.384,22.013,13.521,15.212a7.366,7.366,0,0,0,2.476-4.581c1.559-8.457-9.016-22.8-20.8-21.242C1234.214,1206.11,1220.638,1227.216,1227.522,1230.137Z",
    transform: "translate(-1168.174 -1200.714)",
    fill: "#9460f5"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.72796339bc0760daeb4e4fa6df7cbaf1.svg";
export { ForwardRef as ReactComponent };